export default "__VITE_ASSET__DQlijji7__"